import { FC } from 'react';
import styled, { css } from 'styled-components';

import Button from './Button';

export const StyledButton = styled(Button)<{ $isContentHidden: boolean }>`
  flex-shrink: 0;
  border-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: 4px;
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $isContentHidden }) =>
    $isContentHidden &&
    css`
      background-color: ${({ theme }) => theme.colors.grayscaleLight};
      border-color: ${({ theme }) => theme.colors.grayscaleLight};
    `}
`;

interface Props {
  showContent: boolean;
  onClick: () => void;
}
const ShowHideButton: FC<Props> = ({ showContent, onClick }) => {
  return (
    <StyledButton
      $isContentHidden={!showContent}
      color="secondary"
      onClick={() => onClick()}
    >
      {showContent ? (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 3.93701C3.375 3.93701 1.125 9.00006 1.125 9.00006C1.125 9.00006 3.375 14.062 9 14.062C14.625 14.062 16.875 9.00006 16.875 9.00006C16.875 9.00006 14.625 3.93701 9 3.93701Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 11.8125C10.5533 11.8125 11.8125 10.5533 11.8125 9C11.8125 7.4467 10.5533 6.1875 9 6.1875C7.4467 6.1875 6.1875 7.4467 6.1875 9C6.1875 10.5533 7.4467 11.8125 9 11.8125Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1406 8.95312L15.7444 11.731"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.8438 10.4922L11.3439 13.3289"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.15261 10.4922L6.65234 13.3293"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.85373 8.94922L2.24219 11.7405"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.25 7.375C3.43213 8.83824 5.59927 10.6885 9.00004 10.6885C12.4008 10.6885 14.5679 8.83825 15.7501 7.37502"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </StyledButton>
  );
};

export default ShowHideButton;
